import React, { useContext } from 'react';
import { PriceCalculationContext } from '../../PriceCalculationContext';
import { Select } from '../../../../molecules/input/Select/Select';

function SelectVariant() {
    const { productData, selectedVariantId, setSelectedVariantId, resourcedTexts } =
        useContext(PriceCalculationContext);

    function handleSelect(e) {
        setSelectedVariantId(e.target.value);
    }

    return (
        <div className="select-variant">
            <h4 className="select-variant__heading">{resourcedTexts.selectVariantHeading}</h4>

            <Select
                name="variant"
                labelText={resourcedTexts.selectVariantLabel}
                handleInputChange={handleSelect}
                defaultValue={selectedVariantId}
                options={productData.variantsData.map(({ id, name }) => {
                    return {
                        value: id,
                        text: name,
                    };
                })}
            />
        </div>
    );
}

export { SelectVariant };
